import React from "react";

import { Link } from "ds/Button";
import Dialog from "ds/Dialog";

import * as S from "./styles";

type LabeledInfoProps = {
  gridColumn?: string;
  label: React.ReactNode;
  infoDialog?: boolean;
  infoDialogAlign?: "center" | "start" | "end";
  infoDialogTitle?: string;
  infoDialogText?: string;
  infoDialogLinkText?: string;
  infoDialogLinkTo?: string;
  value: React.ReactNode;
  shouldCapitalize?: boolean;
};
const LabeledInfo = ({
  gridColumn = "auto / span 3",
  label,
  value,
  infoDialog = false,
  infoDialogAlign = "center",
  infoDialogTitle,
  infoDialogText,
  infoDialogLinkText,
  infoDialogLinkTo,
  shouldCapitalize = true
}: LabeledInfoProps) => (
  <S.Layout gridColumn={gridColumn}>
    <S.Value $color="ebony" shouldCapitalize={shouldCapitalize}>
      {value}
    </S.Value>

    <S.Label>
      {label}
      {infoDialog && (
        <Dialog
          align={infoDialogAlign}
          title={infoDialogTitle}
          description={infoDialogText}
          {...(infoDialogLinkTo &&
            infoDialogLinkText && {
              link: <Link href={infoDialogLinkTo}>{infoDialogLinkText}</Link>
            })}
          analyticId={infoDialogText}
        />
      )}
    </S.Label>
  </S.Layout>
);

export default LabeledInfo;
